import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ExportComponent} from './components/export/export.component';
import {ExportReportDirective} from './directives/export-report.directive';
import {EffectsModule} from '@ngrx/effects';
import {DownloadCsvEffects} from './store/effects/download-csv.effects';
import {ReactiveFormsModule} from '@angular/forms';

import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [
        ExportComponent,
        ExportReportDirective
    ],
    exports: [
        ExportComponent,
        ExportReportDirective
    ],
    imports: [
        CommonModule,
        NgbDropdownModule,
        NgbModule,
        ReactiveFormsModule,
        EffectsModule.forFeature([
            DownloadCsvEffects
        ])
    ]
})
export class ExportModule {
}
